export default {
  methods: {
    setTitle() {
      const title = this.title ? `${this.title} | PageMakerPro` : `PageMakerPro`

      window.document.title = title
    }
  },

  created() {
    this.setTitle()
  },

  watch: {
    title() {
      this.setTitle()
    },

    $route() {
      this.setTitle()
    }
  }
}
